import React, { useState } from "react"
import { Link, useHistory } from "react-router-dom"
import DeleteModal from "../../../../components/Common/DeleteModal"
import { usePagination } from "../../../../hooks/usePagination"
import ResultHandler from "../../../../components/ResultHandler"
import PaginationHandler from "../../../../components/PaginationHandler"
import { deleteInvoiceable, getInvoiceables } from "../../../../api/invoiceables"
import TableHeaderHandler from "../../../../components/TableHeaderHandler"
import { useTranslation } from "react-i18next"
import { useResponse } from "../../../../hooks/useResponse"
import TableAction from "../../../../components/TableAction"
import EmptyData from "../../../../components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../../api/permissions";
import { Alert, Button } from "reactstrap"
import ImportCard from "../../../../components/ImportModal"
import { useParams } from "react-router-dom"
import moment from "moment"
import { formatCurrency } from "../../../../utils/formatCurrency"
import AlertModal from "../../../../components/Common/AlertModal"


export default function InvoiceablesTable() {

  const { t } = useTranslation()
  let navigate = useHistory()
  const {contractId} = useParams()

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,

  } = usePagination(getInvoiceables, {contractId})


  //// delete 
  const [show, setShow] = useState(false)

  function onCloseClick() {
    setShow(false)
  }

  const [deletingInvoiceable, setDeletingInvoiceable] = useState(null)

  const { setData } = useResponse(deleteInvoiceable, () => {
    setShow(false)
    setDeletingInvoiceable(null)
    setPayload({contractId, refetch: true})
  })

  function onDeleteClick() {
    setData({ type: "add", data: deletingInvoiceable })
  }

  // Alert Modal
  const [showAlert, setShowAlert] = useState(false)
  const [alertMsg, setAlertMsg] = useState(null)

  ///////////

  const [importModalOpen, setImportModalOpen] = useState(false)


  return (
    <>
      <TableHeaderHandler
        permission={PERMISSIONS.POULE_CREATE}
        setPage={setPage}
        setPerPage={setPerPage}
        addUrl={"/add-invoiceable/"+contractId}
      >
     
      </TableHeaderHandler>

<ImportCard />
      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th>Name</Th>
                <Th>Price</Th>

                <Th style={{ width: "25%" }}>{t("tables.Action")}</Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.invoiceables.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td>{row.name}</Td>
                      <Td>{formatCurrency(row.price)}</Td>
                      <Td>
                        <TableAction
                          hasEdit={true}
                          editPermission={PERMISSIONS.COMPANY_EDIT}
                          type="invoiceable"
                          id={row.id}
                          editUrl={'/edit-invoiceable/'+row.id}
                        />
                        <Button
                          color="danger"
                          onClick={() => {
                            if(row.invoice_id) {
                              setAlertMsg({title: "Sorry!", msg: "Can't delete. It has an Invoice created."})
                              setShowAlert(true)
                            } else {
                              setShow(true)
                              setDeletingInvoiceable(row.id)
                            }
                          }}
                        >
                          <i className="bx bx-trash font-size-16 align-middle" />
                        </Button>
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

          {!loading &&
            <EmptyData empty={response.data && response.data.invoiceables.length === 0} msg="No Invoiceables Found." />
          }
          
          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          <AlertModal
            show={showAlert}
            onCloseClick={() => setShowAlert(false)}
            title={alertMsg?.title}
            msg={alertMsg?.msg}
          />

          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}


          <ResultHandler error={error} loading={loading} />

        </div>
      </div>
    </>
  )
}
